<template>
  <div>
    <t-card v-loading="loading">
      <!-- 請求詳細画面 -->
      <div :style="{ height: basicHeight + 'px', 'padding-top': '10px' }">
        <t-form label-position="right" label-width="90px">
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="請求基本情報" name="sendBasic">
              <t-row type="flex" justify="left">
                <t-col :span="colArr.colL">&nbsp;</t-col>

                <!-- 得意先 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.REQUEST_INFO.CUS_DATA')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="reqInfoEditForm.rbCusInfo"
                      class="commonDialog"
                      :disabled="disabled"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <!-- 請求予定日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.REQUEST_INFO.REQUEST_EXPECTED_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="reqInfoEditForm.rbRequestExpectedDate"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col>

                <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_支払日と請求日の変更 -->
                <!-- 請求日 -->
                <!-- <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.REQUEST_INFO.REQUEST_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="reqInfoEditForm.rbRequestDate"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col> -->
                <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                <!-- 請求状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.REQUEST_INFO.REQUEST_STATUS')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="reqInfoEditForm.rbRequestStatus"
                      class="commonDialog"
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in requestStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 担当者 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.REQUEST_INFO.USER_DATA')"
                    class="marginBottom"
                  >
                    <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="reqInfoEditForm.rbUserCode"
                    >
                      <!-- :placeholder="$t('resource.sys.hidden')" -->
                      <t-option
                        v-for="item in userList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>

              <t-row type="flex" justify="start">
                <t-col :span="colArr.colL">&nbsp;</t-col>

                <t-col :span="colArr.colCom * 5 > 24 ? 24 : colArr.colCom * 5">
                  <t-form-item
                    :label="$t('resource.REQUEST_INFO.BIKOU')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="reqInfoEditForm.rbRemarks"
                      type="textarea"
                      class="commonDialog dialog_bikou"
                      maxlength="500"
                      show-word-limit
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>
        </t-form>
      </div>

      <div :style="{ height: basicButtonHeight + 'px', 'padding-top': '10px' }">
        <t-form label-position="right" label-width="90px">
          <t-row>
            <t-col :span="4" class="col_common_left">
              <!-- 請求製品選択 -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="odProductSelectBtn"
                @click="showReqProductDialog"
                :disabled="productBtnFlg"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.REQUEST_INFO.REQUEST_PRODUCT_SEL") }}
              </t-button></t-col
            >

            <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
            <!-- <t-col :span="16">&nbsp;</t-col> -->
            <!-- 補足データ選択 -->
            <t-col :span="5" class="left">
              <t-button
                round
                type="primary"
                class="button_long_search"
                @click="reqSuppSelectDialog"
                ref="suppSelectBtn"
                :disabled="productBtnFlg"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.CUSTOMER_PAY.CLOSE_DATA_SELECT") }}
              </t-button>
            </t-col>
            <t-col :span="11">&nbsp;</t-col>
            <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

            <t-col :span="4" class="right">
              <!-- 請求書出力 -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="outPutBtn"
                @click="outPutClick"
                :disabled="isAddFlg"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.REQUEST_INFO.REQUEST_OUT_BUTTON") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row>
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="requestInfoTable"
                :data="requestInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :cell-class-name="TableCellClassName"
                :height="detailHeight"
                border
                fit
              >
                <!-- テーブルの列 -->
                <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <t-table-column
                  v-for="(column, index) in columnNameSet()"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="
                    column.prop === 'aodProdRemarksSum'
                      ? true
                      : column.overflowTooltip
                  "
                  :width="
                    column.prop === 'aodProdRemarksSum'
                      ? getRemarksColumnWidthProc()
                      : undefined
                  "
                >
                  <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- 課題_備考機能の追加 -->
                  <template #default="scope">
                    <template v-if="column.prop === 'aodProdRemarksSum'">
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                      <!-- 共通備考の調整 -->
                      <!-- <div class="button-container">
                        <t-tooltip placement="bottom" effect="light">
                          <div
                            slot="content"
                            class="tooltip-content"
                            v-html="
                              formatRemarksShowProc(scope.row.aodProdRemarksSum)
                            "
                          ></div>
                          <t-button
                            :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                            icon="el-icon-search"
                            size="small"
                            circle
                          >
                          </t-button>
                        </t-tooltip>
                      </div> -->
                      <div class="bikouDiv">
                        <!-- 備考表示 -->
                        <span class="bikouText">
                          {{ scope.row.aodProdRemarksSum }}
                        </span>
                      </div>
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                    </template>

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>

                  <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                  <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="24">
                <t-input
                  v-model="amountTotal"
                  style="margin-top: 10px; text-algin: right"
                  :disabled="true"
                  class="sumInput"
                >
                  <template slot="prepend">
                    <span class="span_style">{{
                      $t("resource.REQUEST_INFO.AMOUNT_TOTAL")
                    }}</span></template
                  >
                </t-input>
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <div>
            <t-col :span="20">&nbsp;</t-col>
            <t-col :span="4" align="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="checkConfirm"
                :disabled="btnClickFlg"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import {
  ShowReqProductDialog,
  ShowRequestSuppSelectDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import { outputExcelToZip, updateStatusAfterOutput } from "@/services/common";
import {
  changeRequestData,
  creatRequestData,
  getRequestDetailInfoByNo,
  getRequestSelectInfo,
} from "@/services/requestInfo";
import {
  cmpBasicData,
  cmpDetailData,
  formatCurrencyToNumber,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  getAbleUserInfoList,
  getCurrentDate,
  getDialogContentHeight,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, NUM_ONE, NUM_ZERO } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      activeNames: ["sendBasic"],

      reqInfoEditForm: {
        // 得意先
        rbCusInfo: "",
        // 請求予定日
        rbRequestExpectedDate: "",
        // 請求日
        rbRequestDate: "",
        // 請求状態
        rbRequestStatus: "",
        // 担当者
        rbUserCode: "",
        // 備考
        rbRemarks: "",
      },

      reqPdoductEditForm: {},

      loading: true,

      // 確定ボタンFlag
      btnClickFlg: true,

      productBtnFlg: false,

      // 請求状態
      requestStatusList: [],

      // 担当者
      userList: [],

      isAddFlg: false,

      // ボタン表示Flag
      showFlg: false,

      requestInfoTable: [],

      buttonDisabled: true,

      showCusNoFlg: false,
      disabled: true,

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      suppKbn: 0, //補足データ区分(0:通常データ,1:補足データ)

      // 補足データ選択画面の検索条件
      selectSuppSearchForm: [],
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      // -----------------------

      maxheight: t("widgetSize.orderEditDialog.tableHeight"),
      //テーブルの列
      columns: [
        {
          // 受注日
          prop: "aobAcceptDate",
          label: t("resource.REQUEST_INFO.ORDERED_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 注番
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "aobCusOrderNo",
          prop: "aodCusOrderNo",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          label: t("resource.REQUEST_INFO.ORDER_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "aobCusDeliveryDate",
          prop: "aodCusDeliveryDate",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          label: t("resource.REQUEST_INFO.DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 出荷日
        {
          prop: "sbSendDate",
          label: t("resource.REQUEST_INFO.SEND_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 出荷No
        {
          prop: "sbSendNo",
          label: t("resource.REQUEST_INFO.SEND_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.REQUEST_INFO.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // overflowTooltip: false,
          overflowTooltip: true,
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.REQUEST_INFO.PRODUCT_DRAW_NO"),
          width: "120px",
          class: "cell_txt_left",
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // overflowTooltip: false,
          overflowTooltip: true,
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },

        // 出荷数
        {
          prop: "sendQty",
          label: t("resource.REQUEST_INFO.SEND_QTY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.REQUEST_INFO.AOD_PROD_UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center ",
          overflowTooltip: false,
        },

        // 出荷クローズ数
        // {
        //   prop: "sdProdCloseQty",
        //   label: t("resource.REQUEST_INFO.SEND_CLOSE_QTY"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // 確定売価
        {
          prop: "salesPrice",
          label: t("resource.REQUEST_INFO.SALE_PRINCE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // 合計
        {
          prop: "totalAounnt",
          label: t("resource.REQUEST_INFO.TOTAL"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // 見積No
        {
          prop: "rdQuoteNo",
          label: t("resource.REQUEST_INFO.QUOTE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // overflowTooltip: false,
          overflowTooltip: true,
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },
      ],

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //補足データ列
      suppColumns: [
        // 見積No
        {
          prop: "rdQuoteNo",
          label: t("resource.REQUEST_INFO.QUOTE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        {
          // 受注日
          prop: "aobAcceptDate",
          label: t("resource.REQUEST_INFO.ORDERED_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 注番
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //  prop: "aobCusOrderNo",
          prop: "aodCusOrderNo",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          label: t("resource.REQUEST_INFO.ORDER_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 得意先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //  prop: "aobCusDeliveryDate",
          prop: "aodCusDeliveryDate",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          label: t("resource.REQUEST_INFO.DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.REQUEST_INFO.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.REQUEST_INFO.PRODUCT_DRAW_NO"),
          width: "120px",
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 補足数
        {
          prop: "sendQty",
          label: t("resource.REQUEST_INFO.SUPPLEMENT_COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.REQUEST_INFO.AOD_PROD_UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center ",
          overflowTooltip: false,
        },

        // 補足単価
        {
          prop: "salesPrice",
          label: t("resource.REQUEST_INFO.SUPPLEMENT_U_PRICE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // 補足金額小計
        {
          prop: "totalAounnt",
          label: t("resource.REQUEST_INFO.SUPPLEMENT_AMOUNT"),
          width: "120px",
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        //備考
        // {
        //   prop: "rdRemarks",
        //   label: t("resource.REQUEST_INFO.REMARKS"),
        //   width: t("widgetSize.tableCommon.width170"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // 備考
        {
          label: t("resource.REMARKS_ADD.REMARKS"),
          class: "cell_txt_center",
          prop: "aodProdRemarksSum",
          width: 100,
          scopedSlots: {
            default: "aodProdRemarksSum",
          },
        },
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 3.5,

      //基本情報のheight
      basicButtonHeight: DIALOG_LINE_HEIGHT,

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 4.5,
        DIALOG_LINE_HEIGHT * 2,
        32.5
      ),

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      //列の幅
      // colArr: getEditColWidthArr(window.innerWidth, 5),
      colArr: getEditColWidthArr(window.innerWidth, 4),
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    RowData: {
      Type: Object,
    },
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  created() {
    this.isAddFlg = this.isAdd;

    if (!this.isAdd) {
      this.activeNames = [""];
      this.handleCollapseChange(this.activeNames);
    }

    // 列幅に自動調整
    setColumnWidth(this.columns, this.requestInfoTable);

    // ドロップダウン選択データ取得
    this.getRequestSelectInfo();
  },

  // watch: {
  //   // 状態 = 検収済み  入荷チェックリスト出力表示
  //   "reqInfoEditForm.rbRequestStatus"(value) {
  //     if (value === FINAL_STR.REQUEST_STATUS_END) {
  //       this.productBtnFlg = true;
  //     } else {
  //       this.productBtnFlg = false;
  //     }
  //   },
  // },

  computed: {
    // 金額合計
    amountTotal() {
      let sumTotal = 0;

      // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 請求詳細画面の金額合計の変更
      // if (this.requestInfoTable.length <= 0) {
      //   return sumTotal;
      // } else {
      //   this.requestInfoTable.forEach((element) => {
      //     const amount = formatCurrencyToNumber(element.totalAounnt);

      //     sumTotal = sumTotal + amount;
      //   });
      // }

      let asetSumTotal = 0;  // 一式データ金额合計
      let isASetThirdType = false;  // 1式第3種データのフラグ

      const addedASetQuoteNos = new Set();
      if (this.requestInfoTable.length <= 0) {
        return sumTotal;
      }

      // rdQuoteNoでグループ化
      const quoteGroupMap = new Map();

      this.requestInfoTable.forEach((element) => {
        const quoteNo = element.rdQuoteNo;
        if (!quoteGroupMap.has(quoteNo)) {
          quoteGroupMap.set(quoteNo, []);
        }
        quoteGroupMap.get(quoteNo).push(element);

        // 合計の計算
        const amount = formatCurrencyToNumber(element.totalAounnt);
        sumTotal = sumTotal + amount;
      });

      // 一式第三種であるか否かを判断し、一式金額の合計を計算する（仕入先の加工単価が非0、確定売価が0、一式確定売価が非0）
      for (const [quoteNo, items] of quoteGroupMap) {
        // 条件1：aobASetがtrueとして存在すること
        const hasASetTrue = items.some(item => item.aobASet === true);
        if (!hasASetTrue) continue;

        // 条件2：すべての明細のsalesPriceが0
        const allSalesPriceZero = items.every(item => {
          const salesPrice = formatCurrencyToNumber(item.totalAounnt);
          return salesPrice === 0;
        });

        if (allSalesPriceZero) {
          // 条件3：単位に「式」が含まれていない
          const hasUnitNotShiki = items.some(item => {
            const unit = item.aodProdUnit || '';
            return !unit.includes('式');
          });

          if (hasUnitNotShiki && !addedASetQuoteNos.has(quoteNo)) {
            isASetThirdType = true;
            addedASetQuoteNos.add(quoteNo);
            // そのグループの『一式』の価格を合計する
            const asetPrice = formatCurrencyToNumber(items[0].aobASetSalesPrice);
            asetSumTotal = asetSumTotal + asetPrice;
          }
        }
      }

      // 条件に応じて異なる形式を返す
      if (isASetThirdType) {
        const mainAmount = formatStringToCurrency(sumTotal);
        const asetAmount = formatStringToCurrency(asetSumTotal);
        return `${mainAmount}（${asetAmount}）`;
      }
      // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      return formatStringToCurrency(sumTotal);
    },
  },

  methods: {
    // 初期化
    initScream() {
      if (this.isAddFlg) {
        // 請求日
        this.reqInfoEditForm.rbRequestDate = getCurrentDate(new Date());

        // 請求予定日
        this.reqInfoEditForm.rbRequestExpectedDate = getCurrentDate(new Date());

        // 請求状態
        this.reqInfoEditForm.rbRequestStatus = this.requestStatusList[0].value;

        // 担当者
        this.reqInfoEditForm.rbUserCode = localStorage.getItem("userId");

        this.getAbleList();
        this.loading = false;
      } else {
        this.showCusNoFlg = true;

        this.showFlg = true;

        // 確定ボタンFlag
        this.btnClickFlg = false;

        this.getRequestDetailInfoByNo(this.RowData);
      }
    },

    // 請求詳細画面情報の取得
    getRequestDetailInfoByNo(data) {
      getRequestDetailInfoByNo(data)
        .then((res) => {
          // データの読み込
          this.dataProcess(res);
        })
        .catch((err) => {
          Message.showError(t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE"));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // データの読み込
    dataProcess(data) {
      this.reqInfoEditForm = data.RequestBasicDto;
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //補足データ区分
      this.suppKbn = data.RequestBasicDto.suppKbn;
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      this.requestInfoTable = data.RequestDetailDtos;

      this.tableDataToCurrency(this.requestInfoTable);

      this.getAbleList();

      // //列幅の設定
      setColumnWidth(this.columns, this.requestInfoTable);
    },

    // 通貨書式設定
    tableDataToCurrency(data) {
      if (data.length >= 1) {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          if (element.salesPrice != null) {
            //確定売価
            element.salesPrice = formatStringToCurrency(
              parseInt(element.salesPrice)
            );
          }

          if (element.totalAounnt != null) {
            //合計
            element.totalAounnt = formatStringToCurrency(
              parseInt(element.totalAounnt)
            );
          }
        }
      }

      // 読み込み回数 = 1
      if (!this.isAddFlg && this.numLoads == 1) {
        // 比較用基本情報
        this.cmpBasicResult = JSON.parse(JSON.stringify(this.reqInfoEditForm));

        // 比較用明細情報
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // this.cmpDetailResult = JSON.parse(
        //   JSON.stringify(this.requestInfoTable)
        // );
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extractDetail(this.requestInfoTable))
        );
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    // ドロップダウン選択データ取得
    getRequestSelectInfo() {
      getRequestSelectInfo()
        .then((res) => {
          this.requestStatusList = res.RequestInfoList;

          this.userList = res.UserNames;

          this.initScream();
        })
        .catch((err) => {});
    },

    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },

    // 請求製品選択画面
    showReqProductDialog() {
      if (!this.isAddFlg || this.reqInfoEditForm.rbCusInfo != "") {
        this.reqPdoductEditForm.rbCusInfo = this.reqInfoEditForm.rbCusInfo;
      }

      // 請求製品選択画面
      ShowReqProductDialog(
        {
          isAdd: this.isAddFlg,
          ReqInfoEditForm: this.reqPdoductEditForm,
          RowData: this.requestInfoTable,
          RbRequestExpectedDate: this.reqInfoEditForm.rbRequestExpectedDate,
          reqNo: this.reqInfoEditForm.rbRequestNo,
        },
        t("resource.REQUEST_INFO.REQUEST_PRODUCT_SEL_DIALOG"),
        (target) => {
          if (!!target) {
            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
            if (this.suppKbn !== NUM_ZERO) {
              this.requestInfoTable = [];
              this.suppKbn = NUM_ZERO;
            }
            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
            this.reqInfoEditForm.rbCusInfo = target.rbCusInfo;
            this.reqInfoEditForm.rbRequestExpectedDate =
              target.rbRequestExpectedDate;

            this.showCusNoFlg = true;

            this.showFlg = true;

            // this.isAddFlg = false;

            this.requestInfoTable = target.rowData;
    

            // 確定ボタンFlag
            this.btnClickFlg = false;

            this.reqPdoductEditForm = target.ReqInfoEditForm;

            // 通貨書式設定
            this.tableDataToCurrency(this.requestInfoTable);

            // //列幅の設定
            setColumnWidth(this.columns, this.requestInfoTable);
          }
        }
      );

      // フォーカス削除
      this.$refs.odProductSelectBtn.$el.blur();
    },

    // 使用可能な担当者リスト、得意先リストの取得
    getAbleList() {
      // 担当者リスト
      this.userList = getAbleUserInfoList(
        this.userList,
        this.reqInfoEditForm.rbUserCode
      );
    },

    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;

      if (val.indexOf("sendBasic") !== -1) {
        //基本情報のheight
        this.basicHeight = DIALOG_LINE_HEIGHT * 3.5;

        //基本情報のheight
        this.basicButtonHeight = DIALOG_LINE_HEIGHT;

        //合計情報のheight
        this.bottomHeight = DIALOG_LINE_HEIGHT * 1;

        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          DIALOG_LINE_HEIGHT * 4.5,
          DIALOG_LINE_HEIGHT * 2,
          32.5
        );
      } else {
        //基本情報のheight
        this.basicHeight = DIALOG_LINE_HEIGHT;

        //基本情報のheight
        this.basicButtonHeight = DIALOG_LINE_HEIGHT;

        //合計情報のheight
        this.bottomHeight = DIALOG_LINE_HEIGHT * 1;

        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          DIALOG_LINE_HEIGHT * 2,
          DIALOG_LINE_HEIGHT * 2,
          32.5
        );
      }

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      //列の幅
      // this.colArr = getEditColWidthArr(window.innerWidth, 5);
      this.colArr = getEditColWidthArr(window.innerWidth, 4);
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //「確定」ボタン
    checkConfirm() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      if (this.isAddFlg) {
        this.creatRequestData();
      } else {
        this.changeRequestData();
      }
    },

    // 請求情報の新規作成
    creatRequestData() {
      let requestData = this.editRequestData();

      creatRequestData(requestData)
        .then((res) => {
          this.reqInfoEditForm.requestNo = res;

          this.isAddFlg = false;

          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        })
        .finally(() => {
          const requestData = {
            rbRequestNo: this.reqInfoEditForm.requestNo,
          };

          this.getRequestDetailInfoByNo(requestData);
        });
    },

    // 請求情報の更新処理
    changeRequestData() {
      let requestData = this.editRequestData();

      changeRequestData(requestData)
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

          this.numLoads = 1;
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        })
        .finally(() => {
          this.getRequestDetailInfoByNo(this.reqInfoEditForm);
        });
    },

    //
    editRequestData() {
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      this.reqInfoEditForm.suppKbn = this.suppKbn;
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      //受注タブのテーブル
      var requestDetailDtos = [];
      this.requestInfoTable.map((item, index) => {
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // const requestDetailDto = {
        //     rdRequestQty: item.sendQty,
        //     rdUSalesPrice: item.salesPrice,
        //     rdTotalSales: item.totalAounnt,
        //     // rdRemarks: this.reqInfoEditForm.rbRemarks,
        //     rdSendNo: item.sbSendNo,
        //     rdSendDetailNo: item.sbSendDetailNo,
        //     rdQuoteNo: item.rdQuoteNo,
        //     rdProdNo: item.rdProdNo,
        //     rdCreateTime: item.rdCreateTime,
        //     rdCreateUser: item.rdCreateUser,
        //     rdUpdateTime: item.rdUpdateTime,
        //     rdUpdateUser: item.rdUpdateUser,
        //   };
        var requestDetailDto = {};
        if (this.suppKbn === NUM_ZERO) {
          requestDetailDto = {
            rdRequestQty: item.sendQty,
            rdUSalesPrice: item.salesPrice,
            rdTotalSales: item.totalAounnt,
            // rdRemarks: this.reqInfoEditForm.rbRemarks,
            rdSendNo: item.sbSendNo,
            rdSendDetailNo: item.sbSendDetailNo,
            rdQuoteNo: item.rdQuoteNo,
            rdProdNo: item.rdProdNo,
            rdCreateTime: item.rdCreateTime,
            rdCreateUser: item.rdCreateUser,
            rdUpdateTime: item.rdUpdateTime,
            rdUpdateUser: item.rdUpdateUser,
          };
        } else {
          requestDetailDto = {
            rdRequestQty: item.sendQty,
            rdUSalesPrice: item.salesPrice,
            rdTotalSales: item.totalAounnt,
            rdRemarks: item.rdRemarks,
            rdQuoteNo: item.rdQuoteNo,
            rdProdNo: item.rdProdNo,
            rdCreateTime: item.rdCreateTime,
            rdCreateUser: item.rdCreateUser,
            rdUpdateTime: item.rdUpdateTime,
            rdUpdateUser: item.rdUpdateUser,
          };
        }
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        requestDetailDtos[index] = requestDetailDto;
      });

      const requestData = {
        requestBasicDto: this.reqInfoEditForm,
        requestDetailDtos: requestDetailDtos,
      };

      return requestData;
    },

    //注文書出力
    outPutClick() {
      this.loading = true;

      if (typeof this.$refs.outPutBtn !== "undefined") {
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      }

      let requestData = this.editRequestData();

      changeRequestData(requestData)
        .then((res) => {
          this.numLoads = 1;

          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

          this.outputProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
          this.loading = false;
        });
    },

    outputProcess() {
      outputExcelToZip(
        httpApi.OutPutRequestInfoToExcel,
        this.reqInfoEditForm.rbRequestNo
      )
        // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 start↓
        .then(() => {
          // 出力が成功の場合、手配状態が「手配済み」を変更
          updateStatusAfterOutput({
            statusName: "requestInfoStatus",
            dataNo: this.reqInfoEditForm.rbRequestNo,
          }).then(() => {
            this.numLoads = 1;
            this.getRequestDetailInfoByNo(this.reqInfoEditForm);
          });
        })
        // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑

        .finally(() => {
          this.getRequestDetailInfoByNo(this.reqInfoEditForm);
        });
    },

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.isAddFlg) {
        isDataChanged = this.requestInfoTable.length > 0;
      } else {
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // isDataChanged =
        //   !cmpBasicData(this.cmpBasicResult, this.reqInfoEditForm) ||
        //   !cmpDetailData(this.cmpDetailResult, this.requestInfoTable);
        isDataChanged =
          !cmpBasicData(this.cmpBasicResult, this.reqInfoEditForm) ||
          !cmpDetailData(
            this.cmpDetailResult,
            this.extractDetail(this.requestInfoTable)
          );
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //テーブルで変更される可能性のある列の取得
    extractDetail(data) {
      return data.map((item, index) => {
        return {
          index: index,
          aobAcceptDate: item.aobAcceptDate,
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          // aobCusOrderNo: item.aobCusOrderNo,
          // aobCusDeliveryDate: item.aobCusDeliveryDate,
          aodCusOrderNo: item.aodCusOrderNo,
          aodCusDeliveryDate: item.aodCusDeliveryDate,
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          sbSendDetailNo: item.sbSendDetailNo,
          aodProdName: item.aodProdName,
          aodProdDrawNo: item.aodProdDrawNo,
          sendQty: item.sendQty,
          aodProdUnit: item.aodProdUnit,
          salesPrice: item.salesPrice,
          totalAounnt: item.totalAounnt,
          rdQuoteNo: item.rdQuoteNo,
          rdProdNo: item.rdProdNo,
        };
      });
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.requestInfoTable);
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //列の設定
    columnNameSet() {
      if (this.suppKbn == NUM_ONE) {
        return this.suppColumns;
      }
      return this.columns;
    },

    //補足データ選択画面を表示
    reqSuppSelectDialog() {
      if (typeof this.$refs.suppSelectBtn !== "undefined") {
        // フォーカス削除
        this.$refs.suppSelectBtn.$el.blur();
      }

      var tableData = [];
      if (this.suppKbn === NUM_ONE) {
        tableData = this.requestInfoTable;
      }
      ShowRequestSuppSelectDialog(
        {
          isAdd: this.isAddFlg,
          tableData: tableData,
          rbCusInfo: this.reqInfoEditForm.rbCusInfo,
          rbRequestDate: this.reqInfoEditForm.rbRequestDate,
          selectSuppSearchForm: this.selectSuppSearchForm,
          requestNo: this.reqInfoEditForm.rbRequestNo,
        },
        t("resource.CUSTOMER_PAY.CLOSE_DATA_SELECT"),
        (target) => {
          if (!!target) {
            if (this.suppKbn !== NUM_ONE) {
              this.requestInfoTable = [];
              this.suppKbn = NUM_ONE;
            }
            // 補足データ選択画面の検索条件
            this.selectSuppSearchForm = target.selectSuppSearchForm;
            this.requestInfoTable = target.rowData;
            this.reqInfoEditForm.rbCusInfo = target.rbCusInfo;
            this.reqInfoEditForm.rbRequestExpectedDate =
              target.rbRequestExpectedDate;

            this.requestInfoTable.forEach((item) => {
              //受注日
              item.aobAcceptDate = formatDateToString(item.aobAcceptDate);

              // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
              // 納期、注番の変更(見積単位⇒製品単位に変更)
              // 得意先納期
              //  item.aobCusDeliveryDate = formatDateToString(
              //     item.aobCusDeliveryDate
              //   );
              // 得意先納期
              item.aodCusDeliveryDate = formatDateToString(
                item.aodCusDeliveryDate
              );
              // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

              // 補足単価
              item.salesPrice = formatStringToCurrency(item.salesPrice);
              //補足金額小計
              item.totalAounnt = formatStringToCurrency(item.totalAounnt);
            });
            // 確定ボタンFlag
            this.btnClickFlg = false;
          }
        }
      );
    },

    //セルの配置
    TableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      if (
        (column.property === "sendQty" && row.sendQty < 0) ||
        (column.property === "totalAounnt" &&
          formatCurrencyToNumber(row.totalAounnt) < 0)
      ) {
        return "txt-cell-editable_red";
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.requestInfoTable);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 240px;
}
</style>
